





















































import type { PropType } from '@nuxtjs/composition-api';
// eslint-disable-next-line no-duplicate-imports
import { computed, defineComponent } from '@nuxtjs/composition-api';

import LoadWhenVisible from '~/components/utils/LoadWhenVisible.vue';
import { useLink } from '~/diptyqueTheme/composable';
import type { MediaPreloadableSection } from '~/diptyqueTheme/types/components';
import type { BlockInternalNavigationModel } from '~/integrations/contentful/src/types';

export default defineComponent({
  name: 'BlockInternalNavigation',
  components: {
    LoadWhenVisible,
    VaimoHeading: () => import('atoms/VaimoHeading.vue'),
    VaimoBanner: () => import('atoms/VaimoBanner.vue'),
    VaimoButton: () => import('atoms/VaimoButton.vue')
  },
  props: {
    sectionData: {
      required: true,
      type: Object as PropType<
        BlockInternalNavigationModel & MediaPreloadableSection
      >
    }
  },
  setup(props) {
    const { normalizeLink } = useLink();
    const items = computed(() => {
      if (!props.sectionData.itemsCollection) return [];
      return props.sectionData.itemsCollection?.items.filter((i) => i);
    });

    return {
      items,
      normalizeLink
    };
  }
});
